import React, { useState, useRef } from 'react';
import styled from 'styled-components';

export default function LinkoPayInput(props) {
	const { column, value, setValue, width, disabled, placeholder } = props;

	const [changed, setChanged] = useState(false);

	const inputRef = useRef();

	function handleChange(e) {
		setValue(e.target.value);
		setChanged(true);
	}

	function handleFocus(e) {
		if (!changed) {
			setValue("");
		}
	}

  return (
    <TopLevelWrapper>
      <Column>{column}</Column>
      <Input
        ref={inputRef}
        disabled={disabled}
        value={value}
				width={width}
        placeholder={placeholder}
        onChange={handleChange}
        onFocus={handleFocus} />
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const Column = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	
	margin-top: 8px;
	padding: 0 15px 0 15px;

	outline: none;
	border: 1px solid ${props => props.theme.line};
	border-radius: 8px;
	color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

	width: ${props => props.width}px;
	height: 30px;

	::placeholder {
		color: ${props => props.theme.line};
	}

  &:disabled {
    background-color: ${props => props.theme.subBackground};
  }
`;